import type * as lazyIndex from "./lazyIndex";
import { LazyModule, LazyAction } from "owa-bundling-light";

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(() => import(/* webpackChunkName: "NativeSanitizer" */ "./lazyIndex"), { name: "NativeSanitizer" });

export const lazySanitizeWithNativeAPI: LazyAction<typeof lazyIndex.sanitizeWithNativeAPI, typeof lazyModule> = new LazyAction(lazyModule, m => m.sanitizeWithNativeAPI);

export const lazyLogNonStringInput: LazyAction<typeof lazyIndex.logNonStringInput, typeof lazyModule> = new LazyAction(lazyModule, m => m.logNonStringInput);
